import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import useWindowScrollPosition from 'helpers/useWindowScrollPosition'

import { Container } from 'js/components/Grid'
import PageHeader from 'js/components/PageHeader/PageHeader'
import Section from 'js/components/Section/Section'

import MagazineList from './components/MagazineList'

const ListWrapper = () => {
    const { parentGuid } = useParams()

    const { t } = useTranslation()

    useWindowScrollPosition('magazines')

    return (
        <>
            <PageHeader
                title={t('entity-magazine.name', { count: 2 })}
                canCreate
                createLink="/magazines/add"
                createLabel={t('entity-magazine.create')}
            />
            <Section backgroundColor="white" grow noTopPadding={!parentGuid}>
                <Container>
                    <MagazineList />
                </Container>
            </Section>
        </>
    )
}

export default ListWrapper
